import { useState } from 'react';
import { LoaderBar, SkupremeModal } from '../../components';
import { DangerText, HoverBorderButton, StyledButton, SuccessText } from '../../elements';
import { ToastMessage, ToteService } from '../../utility';
import { palletLimboCheckHook } from '../../hooks';

export function PalletResetPopup({ open, pallet, onClose, refresh }) {
  const { data, loading } = palletLimboCheckHook(pallet?._id);
  const [resetting, setResetting] = useState(false);

  const resetTote = async () => {
    try {
      const payload = {
        type: 'pallet',
        containerId: pallet?._id,
        force: !data.isInLimbo,
      };
      setResetting(true);
      await ToteService.resetContainer(payload);
      ToastMessage.success('Pallet reset successfully');
      refresh();
      onClose();
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      setResetting(false);
    }
  };

  return (
    <SkupremeModal
      title={`Reset Pallet ${pallet?.palletNumber}`}
      open={open}
      onClose={onClose}
      size="mini"
    >
      {loading && <LoaderBar />}
      <div className="mb-4">
        {data?.reason && <p>{data?.reason}</p>}
        {data.isInLimbo ? (
          <SuccessText>This Pallet is not in use</SuccessText>
        ) : (
          <DangerText>This Pallet is in use</DangerText>
        )}
      </div>
      <div className="d-flex justify-content-end">
        <HoverBorderButton disabled={resetting} onClick={onClose}>
          Cancel
        </HoverBorderButton>
        <StyledButton
          onClick={resetTote}
          loading={resetting}
          disabled={loading || !data?.isInLimbo}
          className="ml-2"
        >
          Confirm
        </StyledButton>
      </div>
    </SkupremeModal>
  );
}
